import { getURLParamValue, buildURLobject } from '../global/_getURLParamValue';
import { doScrollToTop } from '../global/_scroll';
import { recoverFacetsFromURL } from './_recoverFacetsFromURL';
import { navImageSliderBinds } from './_navImageSliderBinds';
import { updateFacetCounts } from './_updateFacetCounts';
import { bindFacetsToImageUrl } from './_bindFacetsToImageUrl';
import { handleCatsForOnlyCats } from './_handleCatsForOnlyCats';
import { handleForHiddenIpad } from './_handleForHiddenIpad';
import { tileHover } from './_tileHover';
import { hoverImage } from './_hoverImage';
import { updateOrderByBind } from './_updateOrderByBind';
import { handleChanelTile_dt, handleChanelTile_mobile } from './_handleChanelTile';
import { removeSplash } from './_removeSplash';
import { resultImgMissing } from './_resultImgMissing';
import { updateSortLabel } from './_updateSortLabel';
import { startIntl } from '../international/_intl';
import { doResultListTracking } from './_doResultListTracking';
import { imgSwipe } from './_imgSwipe';
import { swatchCarousel } from './_swatchCarousel';
import { swatchHighlight } from './_swatchHighlight';
import { setBackToBrowsingCookie } from '../../modules/productListing/_setBackToBrowsingCookie';

import { pauseCTMonitor } from '../global/_pauseCTMonitor';

import { getReviewSnippet } from './_powerReviewSnippets';
import Cookies from 'js-cookie';

function disableHashChange() {
	$(window).off('hashchange.resultlist');
}

function enableHashChange() {
	disableHashChange();
	$(window).on('hashchange.resultlist', function () {
		recoverFacetsFromURL(true);
	});
}

function doResultListUpdateRunOnce() {
	enableHashChange();
	updateOrderByBind();
	var seoColorHOne = $('[data-seocolor]');
	if (seoColorHOne.length > 0) {
		var seoFacet = seoColorHOne.data('seocolor').toLowerCase().split('_'),
			toCheck;
		if (seoFacet.length === 2) {
			var attrName = seoFacet[0].trim();
			var attrValue = seoFacet[1].trim();
			toCheck = $(`div[data-urlfacetname="${attrName}"] span[data-urlfacetvalue="${attrValue}"]`);
		} else {
			var attrValue = seoColorHOne.data('seocolor');
			toCheck = $('div[data-urlfacetname="color"] span[data-urlfacetvalue="' + attrValue + '"]');
		}

		if (toCheck.length > 0 && !toCheck.parents('li').find('input').prop('checked')) {
			toCheck.parents('li').find('input').prop('checked', 'checked');
			var toCheckID = $(toCheck).attr('id');
			var filterID = toCheckID.replace('facetLabel_', '');
			$('#filteredBy,.filtered-by').show();
			$('.clearAll').show();
			var filterListHTML = `<li id="filter_${filterID}">
																			<a role="button" href="#" onclick="javascript:Dillards.facetRemoveLink('${toCheck.parents('li').find('input').attr('id')}'); return false;">
																			<span class="label label-default">${toCheck.data('prettyattr')}
																			<i class="remove-filter">&times;</i></span></a></li>`;
			$('#facetFilterList').append(filterListHTML);
			disableHashChange();
			window.location = `${String(window.location).split('#')[0]}#facet=${toCheck.parents('li').find('input').attr('id')}`;
			setTimeout(function () {
				enableHashChange();
			}, 500);
		}
	}

	tileHover();
	resultImgMissing();
}

export var doResultListUpdate = function (fromHashChange, fromOrderBy) {
	var originalFacets = '';
	var facetsToCache = '';
	var personalizedThisList = false;
	if (!Dillards.belowFoldFinished) doResultListUpdateRunOnce();
	var resultListAjaxParams = '';
	doResultListUpdateRunOnce = function () {};
	facetsToCache = '';
	var facetsForCountsCache = '';
	//Static params, hardcoded
	if (fromOrderBy) $('#beginIndex').val(0);
	resultListAjaxParams += `storeId=301&langId=-1&catalogId=301&requesttype=ddsAjax&resultType=products&pageView=grid`;
	if (getURLParamValue('searchType') == 'exact' || getURLParamValue('searchType') == '11') resultListAjaxParams += '&searchType=exact';
	//from DOM     $("#desktopOrderBy").val();
	resultListAjaxParams += `&searchTerm=${$('#searchTerm').val().split('&').join('%26').split('#').join('%23')}&pageSize=${$('#pageSize').val()}&beginIndex=${$(
		'#beginIndex'
	).val()}&orderBy=${$('#orderBy').val()}`;
	facetsToCache += `pageSize=${$('#pageSize').val()}&beginIndex=${$('#beginIndex').val()}&orderBy=${$('#orderBy').val()}`;
	//cache emphasize
	var onlyFlags = '';
	if (String(window.location).indexOf('#') > -1) {
		$(String(window.location).split('#')[1].split('&')).each(function () {
			var thisParam = this.split('=')[0];
			var thisValue = this.split('=')[1];
			if (thisParam == 'emphasize') facetsToCache += `&emphasize=${thisValue}`;
			if (thisParam == 'onlyFlags') {
				facetsToCache += `&onlyFlags=${thisValue}`;
				onlyFlags = thisValue;
			}
		});
	}
	//facet stuff!
	if (originalFacets.length == 0 && $('#onLoadFacets').length > 0) {
		if ($('#onLoadFacets').val().indexOf('manufacturer') > -1) {
			originalFacets +=
				$('#onLoadFacets').val().split('&manufacturer=')[0] + '&manufacturer=' + encodeURIComponent($('#onLoadFacets').val().split('&manufacturer=')[1]);
			if (originalFacets.indexOf('%26facet') > -1)
				originalFacets = originalFacets.split('%26facet')[0] + '&facet' + decodeURIComponent(originalFacets.split('%26facet')[1]);
		} else originalFacets += $('#onLoadFacets').val();
	}
	resultListAjaxParams += originalFacets;

	if ($('.facet').find('input:checked').length > 0) {
		if (originalFacets.indexOf('facet=') == -1) {
			resultListAjaxParams += '&facet=';
		} else {
			resultListAjaxParams += '|';
		}
		facetsToCache += '&facet=';
		facetsForCountsCache += '&facet=';
		$('.facet')
			.find('input:checked')
			.each(function () {
				resultListAjaxParams += $(this).val().split('%2B').join('%252B').split('%C2%AE').join('%25C2%25AE');
				facetsToCache += $(this).attr('id');
				facetsForCountsCache += $(this).attr('id');
				if ($('.facet').find('input:checked').last()[0] != this) {
					resultListAjaxParams += '|';
					facetsToCache += '|';
					facetsForCountsCache += '|';
				}
			});
	}

	if (window.location.href.indexOf('/c/') > 0) {
		resultListAjaxParams += '&super=' + window.location.href.split('/c/')[1].split('-')[0].split('?')[0].split('#')[0].split('/')[0];
	}

	if (
		window.superCat &&
		$('.localstorage').length > 0 &&
		$('.sessionstorage').length > 0 &&
		resultListAjaxParams.indexOf('manufacturer=') == -1 &&
		resultListAjaxParams.indexOf('searchTerm=&') > -1 &&
		resultListAjaxParams.indexOf('emphasize') == -1 &&
		window.isPersonalizationOn &&
		$('#orderBy').val() == 1
	) {
		var existingPersonalizationForSuper = sessionStorage.getItem('sesPz' + window.superCat);
		var existingOldPersonalizationForSuper = sessionStorage.getItem('oldSesPz' + window.superCat);
		if (existingPersonalizationForSuper == null && existingOldPersonalizationForSuper != null)
			existingPersonalizationForSuper = existingOldPersonalizationForSuper;
		var personalizationForSuper = '';
		if (existingPersonalizationForSuper == null) {
			var numAttrs = 0;

			var favoritesDataForSuper = localStorage.getItem('myFavoritespersonalization' + window.superCat);
			if (favoritesDataForSuper != null) {
				$(favoritesDataForSuper.split('|')).each(function () {
					var thisPersonalizationAttr = this;
					if (personalizationForSuper.length > 0) personalizationForSuper += '|';
					personalizationForSuper += 'mfb' + encodeURIComponent(thisPersonalizationAttr.split('&amp;').join('&')).split('%C2%AE').join('%25C2%25AE');
					numAttrs++;
				});
			}

			var personalizationDataForSuper = localStorage.getItem('personalization' + window.superCat);
			if (personalizationDataForSuper != null) {
				$(personalizationDataForSuper.split('|')).each(function () {
					var thisPersonalizationAttr = this;
					if (numAttrs <= 3) {
						if (thisPersonalizationAttr.split('&amp;').join('&').split(';')[1] * 1 >= 3) {
							var newSuperBrand = encodeURIComponent(thisPersonalizationAttr.split('&amp;').join('&').split(';')[0]).split('%C2%AE').join('%25C2%25AE');
							if (personalizationForSuper.indexOf(newSuperBrand) == -1) {
								if (personalizationForSuper.length > 0) personalizationForSuper += '|';
								personalizationForSuper += newSuperBrand;
								numAttrs++;
							}
						}
					}
				});
			}
		} else personalizationForSuper = existingPersonalizationForSuper;

		if (personalizationForSuper.length > 0 && Cookies.get('zCountry') == 'US') {
			personalizedThisList = true;

			sessionStorage.setItem(`sesPz${window.superCat}`, personalizationForSuper);
			sessionStorage.setItem(`oldSesPz${window.superCat}`, personalizationForSuper);
			resultListAjaxParams += `&emphasize=$${personalizationForSuper}`;
			$('#desktopOrderBy').val('0');
		} else {
			personalizedThisList = false;
			sessionStorage.setItem(`sesPz${window.superCat}`, '');
		}
	}
	var scrollToPosition =
		window.location.href.indexOf('scrollTo=') >= 0
			? '&scrollTo=' + window.location.href.substring(window.location.href.indexOf('scrollTo=') + 9, window.location.href.lastIndexOf('scrollTo=') + 18)
			: '';
	if (!fromHashChange) {
		disableHashChange();
		window.location = `${String(window.location).split('#')[0]}#${facetsToCache}${scrollToPosition}`;
		setTimeout(function () {
			enableHashChange();
		}, 500);
	}

	//Update category navigation links to include facetsToCache
	$('.category-nav-facet')
		.find('a')
		.each(function () {
			var thisHref = $(this).attr('href');
			if (thisHref.indexOf('#') > 0) thisHref = thisHref.split('#')[0];
			thisHref += `#pageSize=${$('#pageSize').val()}&=0&orderBy=${$('#orderBy').val()}${facetsForCountsCache}`;
			if (onlyFlags.length > 0) thisHref += `&onlyFlags=${onlyFlags}`;
			$(this).attr('href', thisHref);
		});
	var prodResultsURL = '/shop/DDS_ProductListingView';
	var currentUrl = window.location.href;
	if (currentUrl != null && currentUrl.indexOf('/preview/servlet') > -1) prodResultsURL = '/webapp/wcs/preview/servlet/DDS_ProductListingView';
	//----------Get handlebars template---------------//
	Handlebars.getTemplate = function (name) {
		var version = '1';
		if (typeof versionParam != 'undefined') version = versionParam;
		if (Handlebars.templates === undefined || Handlebars.templates[name] === undefined) {
			return $.ajax({
				url: `/static/app/js/handlebars/${name}.handlebars?v=${version}`,
				success: function (data) {
					if (Handlebars.templates === undefined) Handlebars.templates = {};
					Handlebars.templates[name] = Handlebars.compile(data);
					Handlebars.templates[name]({});
				},
			});
		} else {
			return '';
		}
	};
	//----------/Get handlebars template---------------//

	//----------Get product results template---------------//
	var compiledTemplate;
	//----------/Get product results template---------------//

	//----------Get pagination template---------------//
	var paginationTemplate;
	//----------/Get pagination template---------------//

	Handlebars.registerHelper('escapeDoubleQuote', function (text) {
		text = text.split('#double;').join('&quot;');
		return new Handlebars.SafeString(text);
	});

	Handlebars.registerHelper('brandSplit_brandName', function (brand, text) {
		text = text.split('#double;').join('&quot;');
		let thisBrand1 = `${brand} `,
			thisBrand2 = `${brand}®`,
			splitText = text.toLowerCase().split('&').join('&'),
			brandWithSpace = splitText.indexOf(thisBrand1.toLowerCase()) == 0,
			brandWithR = splitText.indexOf(thisBrand2.toLowerCase()) == 0,
			brandPartOfName = brandWithSpace || brandWithR;
		if (brandPartOfName) {
			let realBrand = brandWithSpace ? thisBrand1 : thisBrand2;
			brand = text.substring(0, realBrand.split('&').join('&').length);
		}
		return new Handlebars.SafeString(brand);
	});

	Handlebars.registerHelper('brandSplit_productName', function (brand, text) {
		text = text.split('#double;').join('&quot;');
		let thisBrand1 = `${brand} `,
			thisBrand2 = `${brand}®`,
			splitText = text.toLowerCase().split('&').join('&'),
			brandWithSpace = splitText.indexOf(thisBrand1.toLowerCase()) == 0,
			brandWithR = splitText.indexOf(thisBrand2.toLowerCase()) == 0,
			brandPartOfName = brandWithSpace || brandWithR;
		if (brandPartOfName) {
			let realBrand = brandWithSpace ? thisBrand1 : thisBrand2;
			text = text.substring(realBrand.split('&').join('&').length);
		}
		return new Handlebars.SafeString(text);
	});

	Handlebars.registerHelper('escapeDoubleQuote_aux', function (text) {
		text = text.split('#double;').join('');
		return new Handlebars.SafeString(text);
	});

	Handlebars.registerHelper('pinItName', function (text) {
		text = text.split('&').join('%26');
		return new Handlebars.SafeString(text);
	});

	Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
		switch (operator) {
			case '==':
				return v1 == v2 ? options.fn(this) : options.inverse(this);
			case '===':
				return v1 === v2 ? options.fn(this) : options.inverse(this);
			case '<':
				return v1 < v2 ? options.fn(this) : options.inverse(this);
			case '<=':
				return v1 <= v2 ? options.fn(this) : options.inverse(this);
			case '>':
				return v1 > v2 ? options.fn(this) : options.inverse(this);
			case '>#':
				return v1 * 1 > v2 * 1 ? options.fn(this) : options.inverse(this);
			case '>=':
				return v1 >= v2 ? options.fn(this) : options.inverse(this);
			case '&&':
				return v1 && v2 ? options.fn(this) : options.inverse(this);
			case '||':
				return v1 || v2 ? options.fn(this) : options.inverse(this);
			default:
				return options.inverse(this);
		}
	});

	Handlebars.registerHelper('pagination', function (currentPage, totalPage, options) {
		var startPage, endPage, context;
		totalPage = totalPage * 1;
		currentPage = currentPage * 1;
		startPage = Math.max(1, currentPage - 1);
		endPage = Math.min(totalPage, currentPage + 1);
		if (currentPage == 1) endPage += 1;
		if (currentPage == totalPage) startPage -= 1;
		context = {
			startFromFirstPage: false,
			pages: [],
			endAtLastPage: false,
			currentPage: currentPage,
		};
		if (currentPage == 1) context.startFromFirstPage = true;
		for (var i = Math.max(startPage, 1); i <= Math.min(endPage, totalPage); i++) {
			var relNext = '';
			var relPrev = '';
			var isStartCurrent = false;
			var isEndCurrent = false;
			var secondPage = 2;
			var prevTotalPage = '';
			var prevPage = '';
			var nextPage = '';
			var notFirstLast = false;
			var notCurrentFirstLast = false;
			var firstButNotCurrent = false;
			var lastButNotCurrent = false;
			if (i == currentPage) {
				if (i == 1) {
					isStartCurrent = true;
					relNext = 'next';
					secondPage = 2;
				}
				if (i == totalPage) {
					isEndCurrent = true;
					relPrev = 'prev';
					prevTotalPage = totalPage - 1;
				}
				if (i != 1 && i != totalPage) {
					notFirstLast = true;
					relNext = 'next';
					relPrev = 'prev';
					prevPage = currentPage - 1;
					nextPage = currentPage + 1;
				}
			} else if (i != currentPage) {
				if (i != 1 && i != totalPage) {
					notCurrentFirstLast = true;
					relNext = 'next';
					relPrev = 'prev';
					prevPage = i - 1;
					nextPage = i + 1;
				}
				if (i == 1) {
					firstButNotCurrent = true;
					relNext = 'next';
					secondPage = 2;
				}
				if (i == totalPage) {
					lastButNotCurrent = true;
					relPrev = 'prev';
					prevTotalPage = totalPage - 1;
				}
			}
			context.pages.push({
				page: i,
				isCurrent: i == currentPage,
				isFirst: i == 1,
				isLast: i == totalPage,
				secondPage: secondPage,
				prevTotalPage: prevTotalPage,
				prevPage: prevPage,
				nextPage: nextPage,
				relAttrNext: relNext,
				relAttrPrev: relPrev,
				isStartCurrent: isStartCurrent,
				isEndCurrent: isEndCurrent,
				neitherFirstLast: notFirstLast,
				neitherCurrentFirstLast: notCurrentFirstLast,
				firstButNotCurrent: firstButNotCurrent,
				lastButNotCurrent: lastButNotCurrent,
			});
		}
		if (currentPage == totalPage) context.endAtLastPage = true;
		return options.fn(context);
	});

	Handlebars.registerHelper('splitSwatches', function (n, block) {
		var accum = '';
		for (var i = 0; i < Math.min(n, 5); ++i) {
			this.thisSwatchGroup = this.swatches.split(';')[i];
			if (this.feiSwatch) this.thisSwatch = this.feiSwatch.split(';')[i];
			accum += block.fn(this);
			this.thisSwatchGroup = '';
		}
		return accum;
	});

	//----------/Register Helpers---------------//

	var data;
	var resultListAjaxBeforeSend = function () {
		pauseCTMonitor(true);
		$(window).unbind('scroll.lazyload');
		$('.no-products').remove();
		if (typeof Dillards.runAfterFirst == 'function') {
			Dillards.runAfterFirst();
		} else {
			Dillards.runAfterFirst = function () {
				$('.result-list').html(
					'<div class="row" id="result-row"><ul><li class="silhouette wrapper-item col-xs-6 col-sm-4 col-md-4"></li><li class="silhouette wrapper-item col-xs-6 col-sm-4 col-md-4"></li><li class="silhouette wrapper-item col-xs-6 col-sm-4 col-md-4"></li><li class="silhouette wrapper-item col-xs-6 col-sm-4 col-md-4"></li><li class="silhouette wrapper-item col-xs-6 col-sm-4 col-md-4"></li><li class="silhouette wrapper-item col-xs-6 col-sm-4 col-md-4"></li><li class="silhouette wrapper-item col-xs-6 col-sm-4 col-md-4"></li><li class="silhouette wrapper-item col-xs-6 col-sm-4 col-md-4"></li><li class="silhouette wrapper-item col-xs-6 col-sm-4 col-md-4"></li></ul></div>'
				);
			};
		}
	};

	// (function() {
	//     var beforePrint = function() {
	//         //console.log('Functionality to run before printing.' +   $("img.product-img").length);
	//         $("img.product-img").each(function() {
	//           $(this).attr("src", $(this).attr("data-original"));
	//           $(this).removeAttr("data-original");
	//         });
	//     };
	//     $(document).bind("keyup keydown", function(e){
	//         if(e.ctrlKey && e.keyCode == 80){
	//         //return false;
	//         beforePrint();
	//       }
	//     });
	//     $(document).bind("contextmenu",function(e){
	//       //return false;
	//       beforePrint();
	//     });
	//
	//     if (window.matchMedia) {
	//         var mediaQueryList = window.matchMedia('print');
	//         mediaQueryList.addListener(function(mql) {
	//             if (mql.matches) {
	//                 beforePrint();
	//             }
	//         });
	//     }
	//
	//     window.onbeforeprint = beforePrint;
	//
	// }());

	var resultListAjaxSuccess = function (responseHtml) {
		var html = responseHtml.replace(/[\u0000-\u001f]/g, '');
		if (!window.failedResultListOnceAlready && html.indexOf('<') == 0) {
			window.failedResultListOnceAlready = true;
			doResultListUpdate();
		} else {
			var $resultList = $('.result-list');
			var $topPagination = $('#pagination-wrapper');
			var $bottomPagination = $('.pagination-footer');
			try {
				data = JSON.parse(html);
				if (!data.products || !data.products.length) {
					updateFacetCounts('');
					data = {
						products: [],
					};
					$resultList.html('');
					pauseCTMonitor(false);
					$topPagination.html('');
					$bottomPagination.html('');
					var newHTML = `<div role="alert" class="alert alert-danger no-products" id="">No products were found that match this criteria.</div>`;
					if (Cookies.get('zCountry') != 'US' && String(window.location).indexOf('/brand/') > -1 && $('.breadcrumb').length > 0)
						newHTML = `<div role="alert" class="alert alert-danger no-products" id="">${$('.breadcrumb')
							.eq(0)
							.find('a')
							.html()} is not available internationally.</div>`;
					if ($('.no-products').length == 0) $('.result-list').before(newHTML);
				} else {
					$resultList.html('<div class="row" id="result-row"><ul></ul></div>');
					$resultList.html(compiledTemplate(data));
					$topPagination.html(paginationTemplate(data));
					data.bottomPagination = 'Dillards.doScrollToTop();';
					$bottomPagination.html(paginationTemplate(data));
					handleForHiddenIpad();
					!($('.mobilePage').length > 0) ? handleChanelTile_dt(data) : handleChanelTile_mobile(data);
					updateFacetCounts(data.facetCounts);
					navImageSliderBinds(facetsToCache);
					bindFacetsToImageUrl(facetsToCache);
					startIntl();
					updateSortLabel();
					handleCatsForOnlyCats();
					removeSplash();
					doResultListTracking(data);
					swatchHighlight();
					setBackToBrowsingCookie();
					pauseCTMonitor(false);
					getReviewSnippet(data.products);
				}
				$(window).off('load.slick');
				$(window).off('resize.slick');
				$(window).off('orientationchange.slick');
				$(window).off('scroll.slick');
				$(document).off('load.slick');
				$(document).off('resize.slick');
				$(document).off('orientationchange.slick');
				$(document).off('scroll.slick');
			} catch (err) {
				updateFacetCounts('');
				data = {
					products: [],
				};
				$resultList.html('');
				pauseCTMonitor(false);
				$topPagination.html('');
				$bottomPagination.html('');
				var newHTML = `<div role="alert" class="alert alert-danger no-products" id="">No products were found that match this criteria.</div>`;
				if (Cookies.get('zCountry') != 'US' && String(window.location).indexOf('/brand/') > -1 && $('.breadcrumb').length > 0)
					newHTML = `<div role="alert" class="alert alert-danger no-products" id="">${$('.breadcrumb')
						.eq(0)
						.find('a')
						.html()} is not available internationally.</div>`;
				if ($('.no-products').length == 0) $('.result-list').before(newHTML);
				newHTML = `<div class="no-products hidden result-list-error-tracking">${err.message}${window.failedResultListOnceAlready ? ' - failedTwice' : ''}</div>
						           <div class="no-products hidden">${err.stack}</div>
											 <div class="no-products hidden">${prodResultsURL}</div>
                       <div class="no-products hidden">${resultListAjaxParams}</div>`;
				$('.result-list').before(newHTML);
			}
			$('.rec-list img').off('appear');
			$('.lazy-img, .rec-list img').lazyload({
				threshold: 100,
				carousel: true,
				//Adding Callback function if needed
				// callback: function(element){
				//
				// }
			});
		}
	};
	var resultListAjaxError = function (jqXHR, textStatus, errorThrown) {
		var $resultList = $('.result-list');
		var $topPagination = $('#pagination-wrapper');
		var $bottomPagination = $('.pagination-footer');
		if (textStatus.indexOf('abort') == -1) {
			var html = jqXHR.responseText.replace(/[\u0000-\u001f]/g, '');
			if (!window.failedResultListOnceAlready && html.indexOf('<') == 0) {
				window.failedResultListOnceAlready = true;
				doResultListUpdate();
			} else {
				updateFacetCounts('');
				data = {
					products: [],
				};
				$resultList.html('');
				pauseCTMonitor(false);
				$topPagination.html('');
				$bottomPagination.html('');
				var newHTML = '<div role="alert" class="alert alert-danger no-products" id="">No products were found that match this criteria.</div>';
				if (Cookies.get('zCountry') != 'US' && String(window.location).indexOf('/brand/') > -1 && $('.breadcrumb').length > 0)
					newHTML =
						'<div role="alert" class="alert alert-danger no-products" id="">' +
						$('.breadcrumb').eq(0).find('a').html() +
						' is not available internationally.</div>';
				if ($('.no-products').length == 0) $('.result-list').before(newHTML);
				newHTML = '<div class="no-products hidden result-list-error-tracking">Non-js error-' + textStatus + '-' + errorThrown + '</div>';
				newHTML += '<div class="no-products hidden">' + prodResultsURL + '</div>';
				newHTML += '<div class="no-products hidden">' + resultListAjaxParams + '</div>';
				$('.result-list').before(newHTML);
			}
		}
	};

	//----------Get product results data---------------//
	if (window.resultListAjaxParams && window.currentRequest && resultListAjaxParams != window.resultListAjaxParams) {
		try {
			window.currentRequest.abort();
		} catch (e) {}
	}
	window.resultListAjaxParams = resultListAjaxParams;
	$.when(
		(window.currentRequest = $.ajax({
			url: prodResultsURL,
			cache: true,
			type: 'GET',
			data: resultListAjaxParams,
			dataType: 'html',
			beforeSend: function () {
				resultListAjaxBeforeSend();
			},
			error: function (jqXHR, textStatus, errorThrown) {
				resultListAjaxError(jqXHR, textStatus, errorThrown);
			},
		})),
		Handlebars.getTemplate('productResults'),
		Handlebars.getTemplate('pagination-tpl')
	).then(function (resultListHTML, productResultsTemplate, paginationTplTemplate) {
		if (!compiledTemplate) {
			compiledTemplate = Handlebars.templates['productResults'];
		}
		if (!paginationTemplate) {
			paginationTemplate = Handlebars.templates['pagination-tpl'];
		}
		if (resultListAjaxParams == window.resultListAjaxParams) {
			try {
				window.currentRequest = false;
			} catch (e) {}
			resultListAjaxSuccess(resultListHTML[0]);
		}
	});
};

export var doCherryResultListUpdate = function (fromHashChange, fromOrderBy) {
	var $resultList = $('.cherry-list');
	if ($resultList.length > 0 && typeof cherryProductJSON != 'undefined') {
		//----------Get handlebars template---------------//
		Handlebars.getTemplate = function (name) {
			var version = '1';
			if (typeof versionParam != 'undefined') version = versionParam;
			if (Handlebars.templates === undefined || Handlebars.templates[name] === undefined) {
				return $.ajax({
					url: `/static/app/js/handlebars/${name}.handlebars?v=${version}`,
					success: function (data) {
						if (Handlebars.templates === undefined) Handlebars.templates = {};
						Handlebars.templates[name] = Handlebars.compile(data);
						Handlebars.templates[name]({});
					},
				});
			} else {
				return '';
			}
		};
		//----------/Get handlebars template---------------//

		//----------Get product results template---------------//
		var compiledTemplate;
		//----------/Get product results template---------------//

		Handlebars.registerHelper('escapeDoubleQuote', function (text) {
			text = text.split('#double;').join('&quot;');
			return new Handlebars.SafeString(text);
		});

		Handlebars.registerHelper('escapeDoubleQuote_aux', function (text) {
			text = text.split('#double;').join('');
			return new Handlebars.SafeString(text);
		});

		Handlebars.registerHelper('pinItName', function (text) {
			text = text.split('&').join('%26');
			return new Handlebars.SafeString(text);
		});

		Handlebars.registerHelper('brandSplit_brandName', function (brand, text) {
			text = text.split('#double;').join('&quot;');
			let thisBrand1 = `${brand} `,
				thisBrand2 = `${brand}®`,
				splitText = text.toLowerCase().split('&').join('&'),
				brandWithSpace = splitText.indexOf(thisBrand1.toLowerCase()) == 0,
				brandWithR = splitText.indexOf(thisBrand2.toLowerCase()) == 0,
				brandPartOfName = brandWithSpace || brandWithR;
			if (brandPartOfName) {
				let realBrand = brandWithSpace ? thisBrand1 : thisBrand2;
				brand = text.substring(0, realBrand.split('&').join('&').length);
			}
			return new Handlebars.SafeString(brand);
		});

		Handlebars.registerHelper('brandSplit_productName', function (brand, text) {
			text = text.split('#double;').join('&quot;');
			let thisBrand1 = `${brand} `,
				thisBrand2 = `${brand}®`,
				splitText = text.toLowerCase().split('&').join('&'),
				brandWithSpace = splitText.indexOf(thisBrand1.toLowerCase()) == 0,
				brandWithR = splitText.indexOf(thisBrand2.toLowerCase()) == 0,
				brandPartOfName = brandWithSpace || brandWithR;
			if (brandPartOfName) {
				let realBrand = brandWithSpace ? thisBrand1 : thisBrand2;
				text = text.substring(realBrand.split('&').join('&').length);
			}
			return new Handlebars.SafeString(text);
		});

		Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
			switch (operator) {
				case '==':
					return v1 == v2 ? options.fn(this) : options.inverse(this);
				case '===':
					return v1 === v2 ? options.fn(this) : options.inverse(this);
				case '<':
					return v1 < v2 ? options.fn(this) : options.inverse(this);
				case '<=':
					return v1 <= v2 ? options.fn(this) : options.inverse(this);
				case '>':
					return v1 > v2 ? options.fn(this) : options.inverse(this);
				case '>#':
					return v1 * 1 > v2 * 1 ? options.fn(this) : options.inverse(this);
				case '>=':
					return v1 >= v2 ? options.fn(this) : options.inverse(this);
				case '&&':
					return v1 && v2 ? options.fn(this) : options.inverse(this);
				case '||':
					return v1 || v2 ? options.fn(this) : options.inverse(this);
				default:
					return options.inverse(this);
			}
		});

		Handlebars.registerHelper('splitSwatches', function (n, block) {
			var accum = '';
			for (var i = 0; i < Math.min(n, 5); ++i) {
				this.thisSwatchGroup = this.swatches.split(';')[i];
				if (this.feiSwatch) this.thisSwatch = this.feiSwatch.split(';')[i];
				accum += block.fn(this);
				this.thisSwatchGroup = '';
			}
			return accum;
		});

		$.when(Handlebars.getTemplate('productResults')).then(function () {
			if (!compiledTemplate) {
				compiledTemplate = Handlebars.templates['productResults'];
			}
			var $resultList = $('.cherry-list');
			cherryProductJSON.categoryForTracking = -10045;
			$resultList.html(compiledTemplate(cherryProductJSON));
			navImageSliderBinds();
			tileHover();
			startIntl();
			resultImgMissing();
			$('.lazy-img').lazyload({
				threshold: 100,
				carousel: true,
			});
		});
		// For Cherry pick pages
	} else {
		$('.lazy-img').lazyload({
			threshold: 100,
			carousel: true,
		});
	}
};
